function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { GenericException, ValidationException } from 'internals/exceptionHandler';
import { getFileName } from 'internals/helpers';
import { handlerValidator, notUndefinedValidator, isBot } from 'internals/validators';
import getAmplitudeEventDispatcherInstance from 'domains/trackingModules/amplitude/AmplitudeEventDispatcher';
import getBrazeDispatcherInstance from 'domains/trackingModules/braze/BrazeEventDispatcher';
import getGtmEventDispatcherInstance from 'domains/trackingModules/gtm/GTMEventDispatcher';
import { TrackingServices } from './constants';
import getSnowplowEventDispatcherInstance from './trackingModules/snowplow/SnowplowEventDispatcher';
var eventDispatcherHandler;
var EventDispatcherHandler = /*#__PURE__*/function () {
  /*
  * This class acts as an interface for all external tracking services.
  * It is responsible for generalizing event dispatchers and deciding what external services should be called.
  * All external services should extend the class GeneralEventTrackingDispatcher, and be passed to the constructor.
  * All tracking services are optional.
  * Always use the factory getEventDispatcherHandlerInstance to instantiate this class.
  */
  function EventDispatcherHandler(_ref) {
    var amplitudeEventDispatcher = _ref.amplitudeEventDispatcher,
      gtmEventDispatcher = _ref.gtmEventDispatcher,
      brazeEventDispatcher = _ref.brazeEventDispatcher,
      appCuesEventDispatcher = _ref.appCuesEventDispatcher,
      snowplowEventDispatcher = _ref.snowplowEventDispatcher;
    _classCallCheck(this, EventDispatcherHandler);
    var bot = isBot();
    this.amplitudeEventDispatcher = handlerValidator(bot ? undefined : amplitudeEventDispatcher);
    this.gtmEventDispatcher = handlerValidator(bot ? undefined : gtmEventDispatcher);
    this.brazeEventDispatcher = handlerValidator(bot ? undefined : brazeEventDispatcher);
    this.appCuesEventDispatcher = handlerValidator(bot ? undefined : appCuesEventDispatcher);
    this.snowplowEventDispatcher = handlerValidator(bot ? undefined : snowplowEventDispatcher);
  }
  return _createClass(EventDispatcherHandler, [{
    key: "logWithDefaultProps",
    value: function logWithDefaultProps(eventName, state) {
      var _this = this;
      var extraProperties = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var trackingServicesList = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [TrackingServices.amplitude, TrackingServices.braze, TrackingServices.appCues];
      var transformers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
      /*
      * This method is responsible for sending both user and event default information to the tracking service.
      */
      try {
        notUndefinedValidator(state);
      } catch (err) {
        throw new ValidationException({
          message: "".concat(err.message, " on method logWithDefaultProps"),
          fileName: getFileName(__filename),
          extra: {
            eventName: eventName,
            trackingServicesList: trackingServicesList
          }
        });
      }
      var payload = extraProperties;
      transformers.forEach(function (func) {
        if (typeof func !== 'function') return;
        payload = func.apply(_this, [payload]);
      });
      try {
        if (trackingServicesList.includes(TrackingServices.amplitude)) {
          this.amplitudeEventDispatcher.logWithDefaultProps(eventName, state, payload);
        }
        if (trackingServicesList.includes(TrackingServices.braze)) {
          this.brazeEventDispatcher.logWithDefaultProps(eventName, state, payload);
        }
        if (trackingServicesList.includes(TrackingServices.appCues)) {
          this.appCuesEventDispatcher.logWithDefaultProps(eventName, state, payload);
        }
        if (trackingServicesList.includes(TrackingServices.snowplow)) {
          this.snowplowEventDispatcher.logWithDefaultProps(eventName, state, payload);
        }
      } catch (e) {
        throw new GenericException({
          message: "Error on logWithDefaultProps: ".concat(JSON.stringify(e.message)),
          fileName: getFileName(__filename),
          extra: {
            eventName: eventName,
            trackingServicesList: trackingServicesList
          }
        });
      }
    }
  }, {
    key: "logWithDefaultEventProps",
    value: function logWithDefaultEventProps(eventName, state) {
      var _this2 = this;
      var extraProperties = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var trackingServicesList = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [TrackingServices.amplitude, TrackingServices.gtm, TrackingServices.braze, TrackingServices.appCues];
      var transformers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
      /*
      * This method is responsible for sending default event information to the tracking service.
      */
      notUndefinedValidator(state);
      var payload = extraProperties;
      transformers.forEach(function (func) {
        if (typeof func !== 'function') return;
        payload = func.apply(_this2, [payload]);
      });
      try {
        if (trackingServicesList.includes(TrackingServices.amplitude)) {
          this.amplitudeEventDispatcher.logWithDefaultEventProps(eventName, state, payload);
        }
        if (trackingServicesList.includes(TrackingServices.braze)) {
          this.brazeEventDispatcher.logWithDefaultEventProps(eventName, state, payload);
        }
        if (trackingServicesList.includes(TrackingServices.gtm)) {
          this.gtmEventDispatcher.logWithDefaultEventProps(eventName, state, payload);
        }
        if (trackingServicesList.includes(TrackingServices.appCues)) {
          this.appCuesEventDispatcher.logWithDefaultEventProps(eventName, state, payload);
        }
        if (trackingServicesList.includes(TrackingServices.snowplow)) {
          this.snowplowEventDispatcher.logWithDefaultEventProps(eventName, state, payload);
        }
      } catch (e) {
        throw new GenericException({
          message: "Error on logWithDefaultEventProps: ".concat(JSON.stringify(e.message)),
          fileName: getFileName(__filename),
          extra: {
            eventName: eventName,
            trackingServicesList: trackingServicesList
          }
        });
      }
    }
  }, {
    key: "setUserProperties",
    value: function setUserProperties(payload) {
      var trackingServicesList = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [TrackingServices.amplitude, TrackingServices.braze, TrackingServices.appCues, TrackingServices.snowplow];
      /*
      * This method is responsible sending user information, defined on the payload param, to the tracking services.
      */
      try {
        if (trackingServicesList.includes(TrackingServices.amplitude)) {
          this.amplitudeEventDispatcher.setUserProperties(payload);
        }
        if (trackingServicesList.includes(TrackingServices.braze)) {
          this.brazeEventDispatcher.setUserProperties(payload);
        }
        if (trackingServicesList.includes(TrackingServices.appCues)) {
          this.appCuesEventDispatcher.setUserProperties();
        }
        if (trackingServicesList.includes(TrackingServices.snowplow)) {
          this.snowplowEventDispatcher.setUserProperties();
        }
      } catch (e) {
        throw new GenericException({
          message: "Error on setUserProperties: ".concat(JSON.stringify(e.message)),
          fileName: getFileName(__filename),
          extra: {
            trackingServicesList: trackingServicesList
          }
        });
      }
    }
  }, {
    key: "setDefaultUserProperties",
    value: function setDefaultUserProperties() {
      var trackingServicesList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [TrackingServices.amplitude, TrackingServices.braze, TrackingServices.appCues, TrackingServices.snowplow];
      /*
      * This method is responsible for sending default user information to the tracking service.
      */
      try {
        if (trackingServicesList.includes(TrackingServices.amplitude)) {
          this.amplitudeEventDispatcher.setDefaultUserProperties();
        }
        if (trackingServicesList.includes(TrackingServices.braze)) {
          this.brazeEventDispatcher.setDefaultUserProperties();
        }
        if (trackingServicesList.includes(TrackingServices.appCues)) {
          this.appCuesEventDispatcher.setDefaultUserProperties();
        }
        if (trackingServicesList.includes(TrackingServices.snowplow)) {
          this.snowplowEventDispatcher.setDefaultUserProperties();
        }
      } catch (e) {
        throw new GenericException({
          message: "Error on setDefaultUserProperties: ".concat(JSON.stringify(e.message)),
          fileName: getFileName(__filename),
          extra: {
            trackingServicesList: trackingServicesList
          }
        });
      }
    }
  }, {
    key: "identify",
    value: function identify(_identify) {
      var trackingServicesList = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [TrackingServices.amplitude];
      /*
      * This method is responsible for updating the tracking service what is the current logged user information.
      */
      if (trackingServicesList.includes(TrackingServices.amplitude)) {
        this.amplitudeEventDispatcher.identify(_identify);
      }
    }
  }]);
}();
var getEventDispatcherHandlerInstance = function getEventDispatcherHandlerInstance() {
  /*
  * Factory responsible for generating a singleton. Only one instance of EventDispatcherHandler must exist at a time.
  */
  if (eventDispatcherHandler) {
    return eventDispatcherHandler;
  }
  var dispatcherParams = arguments.length <= 0 ? undefined : arguments[0];
  if (dispatcherParams.defaultModules && dispatcherParams.userFetcher) {
    dispatcherParams.amplitudeEventDispatcher = getAmplitudeEventDispatcherInstance(dispatcherParams.userFetcher);
    dispatcherParams.brazeEventDispatcher = getBrazeDispatcherInstance(dispatcherParams.userFetcher);
    dispatcherParams.gtmEventDispatcher = getGtmEventDispatcherInstance(dispatcherParams.userFetcher);
    dispatcherParams.snowplowEventDispatcher = getSnowplowEventDispatcherInstance(dispatcherParams.userFetcher);
  }
  eventDispatcherHandler = new EventDispatcherHandler(dispatcherParams);
  return eventDispatcherHandler;
};
export { EventDispatcherHandler };
export default getEventDispatcherHandlerInstance;